import React from 'react';
import { brand } from '../../config/brand';
import { useReveal } from '../../hooks/useReveal';
import './About.css';

const About: React.FC = () => {
  const ref = useReveal();

  return (
    <section className="about section" id="about" aria-labelledby="about-heading" ref={ref}>
      <div className="container">
        <div className="about__inner">
          <div className="about__copy">
            <span className="section-label">The team behind ZinifyLabs</span>

            {/* Identity row: the photo is an avatar inside the block, not a
                plate beside it. */}
            <div className="about__id reveal reveal-delay-1">
              <img
                src="/profile.png"
                alt="Augustinas Žinys — Founder of ZinifyLabs"
                className="about__avatar"
                width={52}
                height={52}
              />
              <div className="about__id-text">
                <h2 className="about__name" id="about-heading">{brand.founder.name}</h2>
                <p className="about__founder-role">{brand.founder.role}</p>
              </div>
              <span className="about__id-meta">
                {brand.agency.region} · {brand.agency.location}
              </span>
            </div>
            <p className="about__bio reveal reveal-delay-3">{brand.founder.bio}</p>

            <ul className="about__highlights reveal reveal-delay-4">
              {brand.founder.highlights.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
